'use client';
import LoginForm from './_components/forms/login-form/LoginForm';
import PageLoaderProvider from './_components/providers/page-loader-provider/PageLoaderProvider';
import './_styles/index.scss';

import styles from './page.module.scss';

export default function Home() {
  return (
    <PageLoaderProvider>
      <div className={styles.pageWrapper}>
        <header>
          <h1>Winteria App</h1>
        </header>

        <LoginForm />
      </div>
    </PageLoaderProvider>
  );
}
